import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

import App from "./app/app.slice";
import Auth from "./auth/auth.slice";
import Media from "./media/media.slice";
import Stinger from "./stinger/stinger.slice";
import Upload from "./upload/upload.slice";
import { configureStore } from "@reduxjs/toolkit";
import logger from "redux-logger";
import UserSlice from "./user/user.slice";
import ConstantSlice from "./constants/constants.slice";

// Create and configure the store
export const store = configureStore({
  reducer: {
    app: App,
    auth: Auth,
    media: Media,
    upload: Upload,
    stinger: Stinger,
    users: UserSlice,
    constants: ConstantSlice,
    // [authApi.reducerPath]: authApi.reducer,
    // [mediaApi.reducerPath]: mediaApi.reducer,
    // upload : uploadSlice,
    // [uploadApi.reducerPath]: uploadApi.reducer,
  },
  middleware: (getDefaultMiddleware) => {
    const middleware = getDefaultMiddleware();
    // Only add redux-logger in development
    if (process.env.NODE_ENV !== "production") {
      middleware.push(logger);
    }
    return middleware;
  },
  // middleware: (getDefaultMiddleware) =>
  //   getDefaultMiddleware()
  //     .concat(authApi.middleware)
  //     .concat(mediaApi.middleware),
  devTools: process.env.NODE_ENV !== "production", // Enable Redux DevTools in development
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>; // Type of the entire Redux state
export type AppDispatch = typeof store.dispatch; // Type for dispatch

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
